import React, { useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import { useController } from 'react-hook-form';
import TextArea from '../text-area';
import transfromRequiredRule from '../../helpers/transform-required-rule';
import { TextAreaProps } from '../text-area/types';

const defaultRules = {};

const TextAreaField = ({
  name,
  control,
  rules: passedRules = defaultRules,
  elementAfter = null,
  onChange = Function.prototype,
  onBlur = Function.prototype,
  ...otherProps
}) => {
  const rules = useMemo(() => transfromRequiredRule(passedRules), [passedRules]);

  const { field, fieldState } = useController({
    name,
    control,
    rules,
  });

  const handleChange = useCallback(
    (...args) => {
      field.onChange(...args);
      if (onChange) onChange(...args);
    },
    [field, onChange]
  );

  const handleBlur = useCallback(
    (...args) => {
      field.onBlur();
      if (onBlur) onBlur(...args);
    },
    [field, onBlur]
  );

  const isElementAfter = Boolean(elementAfter);

  return (
    <React.Fragment>
      <TextArea
        {...otherProps}
        inputRef={field.ref}
        value={field.value}
        name={field.name}
        invalid={fieldState.invalid}
        statusText={(!isElementAfter && fieldState.error?.message) || null}
        onChange={handleChange}
        onBlur={handleBlur}
      />
      {isElementAfter && elementAfter}
    </React.Fragment>
  );
};

TextAreaField.propTypes = {
  ...TextAreaProps,
  name: PropTypes.string.isRequired,
  control: PropTypes.shape({}).isRequired,
  rules: PropTypes.shape({}),
  elementAfter: PropTypes.node,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
};

export default TextAreaField;
